import { useState, useEffect, useContext } from 'react';

import { SocketContext } from '../context';

const useMeetingProcessing = () => {
  const [processing, setProcessing] = useState({
    percentage: 0,
    step: '',
    meetingId: '',
  });

  const { socket } = useContext(SocketContext);

  useEffect(() => {
    const getMeetingProcessing = ({ percentage, step, meetingId }) => {
      setProcessing({
        percentage,
        step,
        meetingId,
      });
    };

    socket.on('processing', getMeetingProcessing);

    return () => {
      socket.removeListener('processing', getMeetingProcessing);
    };
  }, [socket]);

  return processing;
};

export default useMeetingProcessing;
